import {CrmSyncAccountDefaultFieldIdsEnum} from '../../../../models/api/crmSyncModel';
import {CrmToFrontCustomFieldMapping} from '../common/crmSyncHelpers';

/*
 * Constants.
 */

export const HubspotMaxAllAccounts = 150000;
export const HubspotMaxAccountsCountable = 5000; // the max number of accounts we can count for hubspot
export const LinkToHubspot = 'https://app.hubspot.com';
export const hubspotHelpCenterArticle = 'https://help.front.com/t/y4hdac2';

export enum HubspotDefaultCustomFieldIdsEnum {
  NAME = 'name',
  DOMAINS = 'domain',
  DESCRIPTION = 'description',
}

export const HubspotRequiredDefaultFields: ReadonlyArray<CrmToFrontCustomFieldMapping> = [
  {
    crmFieldId: HubspotDefaultCustomFieldIdsEnum.NAME,
    customFieldId: CrmSyncAccountDefaultFieldIdsEnum.NAME,
  },
];

export const HubspotOptionalDefaultFields: ReadonlyArray<CrmToFrontCustomFieldMapping> = [
  {
    crmFieldId: HubspotDefaultCustomFieldIdsEnum.DOMAINS,
    customFieldId: CrmSyncAccountDefaultFieldIdsEnum.DOMAINS,
  },
  {
    crmFieldId: HubspotDefaultCustomFieldIdsEnum.DESCRIPTION,
    customFieldId: CrmSyncAccountDefaultFieldIdsEnum.DESCRIPTION,
  },
];
